import { Tooltip, Typography } from "@mui/material";
import type { ReactNode } from "react";
import useHorizontalOverflowDetection from "@entrilia/shared/hooks/useHorizontalOverflowDetection.ts";

interface Props {
  caption: string;
  color?: string;
  overflowTooltip?: ReactNode;
}

const SubCaption = ({ caption, color, overflowTooltip }: Props) => {
  const { hasOverflow, containerRef } = useHorizontalOverflowDetection([caption]);

  const text = (
    <Typography variant="caption" noWrap ref={containerRef} sx={{ textAlign: "end", color: color || "primary.main" }}>
      {caption}
    </Typography>
  );

  if (overflowTooltip === undefined) {
    return text;
  }

  return (
    <Tooltip title={hasOverflow ? overflowTooltip : ""} arrow disableInteractive>
      {text}
    </Tooltip>
  );
};

export default SubCaption;
